import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Brokers from "@/pages/Brokers";
import Strategies from "@/pages/Strategies";
import StrategyBuilder from "@/pages/StrategyBuilder";
import Backtest from "@/pages/Backtest";
import Autotrade from "@/pages/Autotrade";
import Positions from "@/pages/Positions";
import Logs from "@/pages/Logs";
import AdminPanel from "@/pages/AdminPanel";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <div className="min-h-screen flex items-center justify-center text-slate-400 font-mono text-sm">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <div className="min-h-screen flex items-center justify-center text-slate-400 font-mono text-sm">Loading…</div>;
  if (user) return <Navigate to="/dashboard" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/brokers" element={<Protected><Brokers /></Protected>} />
            <Route path="/strategies" element={<Protected><Strategies /></Protected>} />
                        <Route path="/builder" element={<Protected><StrategyBuilder /></Protected>} />
            <Route path="/builder/:id" element={<Protected><StrategyBuilder /></Protected>} />
            <Route path="/backtest" element={<Protected><Backtest /></Protected>} />
            <Route path="/autotrade" element={<Protected><Autotrade /></Protected>} />
            <Route path="/positions" element={<Protected><Positions /></Protected>} />
            <Route path="/logs" element={<Protected><Logs /></Protected>} />
            <Route path="/admin" element={<Protected><AdminPanel /></Protected>} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
